import script from "./AddAccountForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAccountForm.vue?vue&type=script&setup=true&lang=js"

import "./AddAccountForm.vue?vue&type=style&index=0&id=3a29dc9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a29dc9f"]])

export default __exports__